import { render, staticRenderFns } from "./messageBoard.vue?vue&type=template&id=93ab063a&scoped=true&"
import script from "./messageBoard.vue?vue&type=script&lang=js&"
export * from "./messageBoard.vue?vue&type=script&lang=js&"
import style0 from "./messageBoard.vue?vue&type=style&index=0&id=93ab063a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93ab063a",
  null
  
)

export default component.exports